import React from "react";
import PropTypes from "prop-types";
import Drawer from "@mui/material/Drawer";

const DrawerWrapper = ({ children, open, closeDrawer, noOverlay }) => {
  const drawerStyle = {
    position: "fixed",
    left: "auto",
    right: 0,
    width: "calc(100% - 239px)",
    height: "calc(100% - 72px)",
    bottom: 0,
    top: "auto",
    ...(noOverlay && { backgroundColor: "transparent" }),
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      ModalProps={{
        BackdropProps: {
          style: drawerStyle,
        },
      }}
      style={drawerStyle}
    >
      {children}
    </Drawer>
  );
};

DrawerWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  noOverlay: PropTypes.bool,
};

export default DrawerWrapper;
